var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYandexmap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 11.35c0-4.997 0-7.495 1.552-9.048C3.855.75 6.353.75 11.35.75h5.3c4.997 0 7.495 0 9.048 1.552 1.552 1.553 1.552 4.051 1.552 9.048v5.3c0 4.997 0 7.495-1.552 9.048-1.553 1.552-4.051 1.552-9.048 1.552h-5.3c-4.997 0-7.495 0-9.048-1.552C.75 24.145.75 21.647.75 16.65v-5.3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2 12.36V8.788H7.258c-.645 0-1.15.158-1.514.473-.359.31-.538.748-.538 1.31 0 .568.18 1.01.538 1.325.36.31.864.466 1.514.466h1.944zm-1.673 1.5-2.643 3.865h-2.11l2.853-4.127c-.709-.204-1.276-.575-1.703-1.113-.427-.539-.64-1.18-.64-1.922 0-.995.334-1.8 1.004-2.416.67-.617 1.552-.925 2.649-.925h4.127v10.503H9.2V13.86H7.526zm6.173 4.018c-.34 0-.619-.11-.837-.328a1.115 1.115 0 0 1-.328-.822c0-.335.11-.609.328-.823.218-.218.497-.327.837-.327.344 0 .623.11.837.328.218.213.327.487.327.822 0 .33-.109.604-.327.822-.214.219-.493.328-.837.328zm4.506-6.143h.32l3.945-4.513h2.155l-4.506 5.11 4.84 5.393h-2.314l-4.112-4.498h-.328v4.498h-1.878V7.222h1.878v4.513z",
    fill: "#F43"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 11.35c0-4.997 0-7.495 1.552-9.048C3.855.75 6.353.75 11.35.75h5.3c4.997 0 7.495 0 9.048 1.552 1.552 1.553 1.552 4.051 1.552 9.048v5.3c0 4.997 0 7.495-1.552 9.048-1.553 1.552-4.051 1.552-9.048 1.552h-5.3c-4.997 0-7.495 0-9.048-1.552C.75 24.145.75 21.647.75 16.65v-5.3z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandexmap);
export default __webpack_public_path__ + "static/media/yandexmap.afe147b0ceb34d05f6d76ab256d2c011.svg";
export { ForwardRef as ReactComponent };